import * as React from "react";
import Grid from "@material-ui/core/Grid";
import { withStyles, FormControl } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import ReactSelect2 from "common/components/ReactSelect2";
import Select from "react-select";
import { CostPlanStore } from "modules/costPlan/CostPlanStore";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { Delete } from "@material-ui/icons";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
// import Icon from './../common/Icon';
import i18n from "i18n";
import { any, number } from "prop-types";
import { LoginStore } from "modules/login/LoginStore";

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiInput: {
      underline: {
        "&:after": {
          borderBottom: "2px solid #9aaf00",
        },
      },
    },
    MuiFormLabel: {
      root: {
        "&$focused": {
          color: "#9AAF00",
        },
      },
    },
  },
});

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
    color: "#5175B9",
    border: "1px solid rgba(81, 117, 185, 0.5)",
    marginTop: "1rem",
    padding: "5px 15px",
  },
  textField: {
    width: "90%",
    // marginTop: "0px",
  },
  input: {
    fontFamily: "Roboto",
    fontSize: "12px",
    fontWeight: 400,
    width: "90%",
    margin: "0 auto",
    // marginTop: "12px",
    marginTop: "28px",
    display: "block",
    "& :focus": {
      backgroundColor: "white",
    },
  },
  rowBudget: {
    // marginBottom: "5px",
    "&:hover": {
      "& :nth-child(3)": {
        "& svg": {
          opacity: 1,
        },
      },
    },
    "& :nth-child(3)": {
      "& svg": {
        transition: ".5s",
        cursor: "pointer",
        opacity: 0,
      },
    },
  },
  trash: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: "30px",
    // paddingTop: "15px",
    color: "#888",
  },
});

type IProps = {
  classes: any;
};

const alphabet: string[] = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

class CustomBudget extends React.Component<IProps> {
  state = {
    fields: [{ value: -1 }],
    letter: Array(),
    name: Array(),
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (CostPlanStore.arrayObjCustomBudget.length > 0) {
      CostPlanStore.arrayObjCustomBudget.map((custom, index) => {
        this.state.letter.splice(index, 1, {
          label: alphabet[custom.column],
          value: custom.column,
        });

        CostPlanStore.setFieldsCustomBudgetValue(custom.column, index);
        this.state.name.splice(index, 1, custom.label);
        this.state.fields.splice(index, 1, { value: -1 });
      });

      this.setState({
        letter: [...this.state.letter],
        name: [...this.state.name],
      });
    } else {
      if (LoginStore.userAuth!.updateFileConfig) {
        if (LoginStore.userAuth!.updateFileConfig.customProperties) {
          LoginStore.userAuth!.updateFileConfig.customProperties.map(
            (custom, index) => {
              this.state.letter.splice(index, 1, {
                label: alphabet[custom["column"]],
                value: custom["column"],
              });
              this.state.name.splice(index, 1, custom["label"]);
              this.state.fields.splice(index, 1, { value: -1 });
              CostPlanStore.setFieldsCustomBudgetValue(custom["column"], index);

              this.setState({
                letter: [...this.state.letter],
                name: [...this.state.name],
              });
            }
          );
          if (CostPlanStore.arrayObjCustomBudget) {
            CostPlanStore.arrayObjCustomBudget =
              LoginStore.userAuth!.updateFileConfig.customProperties;
          }
        }
      }
    }
  }

  handleChangeKey = (key) => (event) => {
    this.state.name.splice(key, 1, event.value);
    this.setState({ name: this.state.name });
  };

  shouldComponentUpdate() {
    return true;
  }

  render() {
    const { classes } = this.props;

    const handleClickNewCustomField = () => {
      this.setState({
        fields: [
          ...this.state.fields,
          {
            value: -1,
          },
        ],
      });
    };
    const addName = (value, key) => {
      this.state.name.splice(key, 1, value);
      this.setState({
        name: [...this.state.name],
      });
    };

    const handleChangeValue = (event, key) => {
      if (event === null) {
        CostPlanStore.setFieldsCustomBudgetValue({ value: -1 }, key);
        event = { value: "" };
        let evento = this.state.letter.splice(key, 1, event);
      } else {
        CostPlanStore.setFieldsCustomBudgetValue(event.value, key);
        let evento = this.state.letter.splice(key, 1, event);
      }

      this.setState({ letter: this.state.letter });
    };

    const handleClickDeletCustomField = (key) => {
      this.state.fields.splice(key, 1);
      this.state.name.splice(key, 1);
      this.state.letter.splice(key, 1);
      this.setState({
        fields: [...this.state.fields],
        name: [...this.state.name],
        letter: [...this.state.letter],
      });
    };

    return (
      <div>
        <p style={{ textAlign: "center", fontWeight: 500 }}>
          {i18n.wbs.createProperties}
        </p>

        {/* Aqui */}
        <div>
          {this.state.fields.map((field, key) => (
            <Grid className={classes.rowBudget} container>
              <Grid item xs={6}>
                <MuiThemeProvider theme={theme}>
                  <TextField
                    style={{ color: "black!important" }}
                    id="standard-name"
                    label={i18n.wbs.name}
                    className={classes.textField}
                    value={this.state.name[key]}
                    onChange={this.handleChangeKey(key)}
                    autoFocus={key == 0 ? true : false}
                    onBlur={(event) => {
                      CostPlanStore.setFieldsCustomBudgetKey(
                        event.target.value,
                        key
                      );
                      addName(event.target.value, key);
                    }}
                    margin="normal"
                  />
                </MuiThemeProvider>
              </Grid>
              <Grid item xs={5}>
                <FormControl className={classes.input}>
                  <MuiThemeProvider theme={theme}>
                    <ReactSelect2
                      listValues={alphabet}
                      handleChange={(event) => handleChangeValue(event, key)}
                      value={this.state.letter[key]}
                      placeholder={i18n.wbs.column}
                      boxLine={key}
                      boxType="customBudget"
                    />
                  </MuiThemeProvider>
                </FormControl>
              </Grid>
              <Grid item xs={1} className={classes.trash}>
                <Delete
                  onClick={() => {
                    CostPlanStore.unsetFieldsCustomBudgetKeyAndValue(key);
                    handleClickDeletCustomField(key);
                  }}
                />
              </Grid>
            </Grid>
          ))}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            style={{
              color: "#9AAF00",
              backgroundColor: "#00000000",
              border: "1px solid",
              marginTop: "1rem",
              padding: "5px 15px",
              boxShadow: "initial",
            }}
            onClick={handleClickNewCustomField}
          >
            + {i18n.wbs.newProperty}
          </Button>
        </div>
      </div>
    );
  }
}

export default withStyles(styles as any)(CustomBudget);



// WEBPACK FOOTER //
// ./src/modules/costPlan/components/pages/CustomBudget.tsx